<template>
  <div>
    <UiButton
      @click="emit('toggleAction')"
      data-testid="dropdown-menu-button"
      position="TOP_RIGHT"
    >
      <div :class="getMenuButtonClasses">
        <div class="menubutton__usericon">
          <span data-testid="menubutton-usericon">
            {{ currentUserInitials }}
          </span>
        </div>
        <div class="menubutton__userinfo">
          <div class="menubutton__fullname subtitle-2">
            <span data-testid="menubutton-fullname">
              {{ userName }}
            </span>
          </div>
          <div
            class="menubutton__carriername"
            data-testid="menubutton-carriername"
          >
            {{ companyName }}
          </div>
        </div>
        <span class="menubutton__menuicon">
          <ui-icon type="round"> menu </ui-icon>
        </span>
      </div>
    </UiButton>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useUserDetailsStore } from '@/stores/useUserDetails';

const emit = defineEmits(['toggleAction']);

const props = defineProps({
  isProfile: {
    type: Boolean,
    default: false,
  },
});

const { currentUserInitials, userName, companyName } = storeToRefs(
  useUserDetailsStore()
);

const getMenuButtonClasses = computed(() => {
  return ['menubutton', props.isProfile ? 'menubutton--profile' : ''];
});
</script>

<style lang="scss" scoped>
@use '@/assets/scss/fonts.scss';

.menubutton {
  @apply tw-flex
    tw-flex-row
    tw-items-center
    tw-justify-center
    tw-cursor-pointer
    tw-text-black-500;

  .menubutton__usericon {
    @apply tw-bg-primary-base
        tw-capitalize
        tw-font-medium
        tw-text-center
        tw-text-white;

    height: 30px;
    width: 30px;
    border-radius: 100px;
    font-size: 16px;
    line-height: 30px;

    @screen tw-md {
      margin-right: 10px;
    }
  }

  .menubutton__userinfo {
    @apply tw-hidden
          tw-md:tw-flex
          tw-flex-col
          tw-items-start;
    padding-right: 23px;
    line-height: 1;
  }

  .menubutton__fullname {
    @apply tw-text-grey-dark
          tw-font-medium
          tw-text-left
          tw-mb-1;
  }

  .menubutton__carriername {
    @apply tw-text-grey-dark
        tw-font-regular
        tw-text-xs
        tw-capitalize;
  }

  .menubutton__menuicon {
    @apply tw-hidden
        tw-md:tw-flex
        tw-text-grey-dark;
  }

  &.menubutton--profile {
    .menubutton__usericon {
      margin-right: 18px;

      @apply tw-w-8
      tw-h-8
      tw-leading-8;
    }

    .menubutton__fullname {
      @apply tw-text-grey-dark-x
      tw-text-base
      tw-leading-6
      tw-mb-1;
      letter-spacing: 0.25px;
    }

    .menubutton__carriername {
      @apply tw-text-sm;
      letter-spacing: 0.25px;
      line-height: 21px;
    }

    .menubutton__userinfo {
      @apply tw-block;
    }
  }

  .menubutton__admin {
    @apply tw-text-drivably-primary-base
        tw-relative
        tw-left-3
        -tw-top-1
        tw-bg-white
        tw-rounded-full
        tw-border-1
        tw-border-solid
        tw-p-1
        tw-scale-75;
  }
}
</style>
